import {Component} from '@angular/core';
import {ProcessingClassSubType} from '../../../../types/types';

@Component({
  selector: 'app-case-hospital',
  templateUrl: './case-hospital.component.html',
  styleUrls: []
})
export class CaseHospitalComponent {
  readonly processingClassSubType = ProcessingClassSubType;
}
